var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('v-app',[_c('Header'),_c('div',{staticClass:"page-layout"},[_c('div',{staticClass:"columns"},[_c('div',{staticClass:"column is-offset-1 is-10"},[_c('v-content',[_c('v-container',{attrs:{"fluid":""}},[_c('vue-page-transition',{attrs:{"name":"fade-in-left"}},[_c('router-view')],1)],1)],1)],1)])]),_c('Footer')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }